import useWepapp from "./useWepapp";

const useVerify = () => {
    const p5 = "verify page"

    return {
        p5,
    }
}
export default useVerify;